import { Image } from "@mantine/core";
import GenericLogo from "@/components/Logos/GenericLogo";
import SmartWizLogo from "@/components/Logos/SmartWizLogo";
import React from "react";

interface AuthLogoProps {
  logoUrl?: string;
  businessSlug?: string;
  primaryColor?: string;
  size?: number;
  isSmall?: boolean;
  alt?: string;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  style?: React.CSSProperties;
  className?: string;
}

const AuthLogo: React.FC<AuthLogoProps> = ({
  logoUrl,
  businessSlug,
  primaryColor = "#0077CC",
  size = 72,
  isSmall = true,
  alt = "Business Logo",
  onError,
  style,
  className,
}) => {
  if (logoUrl) {
    return (
      <Image
        src={logoUrl}
        alt={alt}
        height={size}
        width={size}
        radius="md"
        onError={onError}
        fit="contain"
        style={style}
        className={className}
      />
    );
  } else if (businessSlug) {
    return <GenericLogo color={primaryColor} width={size} height={size} />;
  } else {
    return <SmartWizLogo isSmall={isSmall} color="white" />;
  }
};

export default AuthLogo;
